import { slaMetricsDataResource } from '@atlassian/jira-router-resources-service-desk-sla-settings';
import { useResource } from '@atlassian/react-resource-router';

export const useMetricResource = () => {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const { data, loading, error, refresh, update } = useResource<any>(slaMetricsDataResource);

	return [
		{ data, loading, error },
		{ refresh, update },
	] as const;
};
